import addActivityTemplate from './../../settings/add-activity/add-activity.html';
import editActivityTemplate from './../../settings/edit-activity/edit-activity.html';
import _remove from 'lodash/remove';
import './activities.scss';
import template from './activities.html';

class ActivitiesComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    SchoolCommonRoomService,
    ActivityService,
    UtilService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.ActivityService = ActivityService;
    this.UtilService = UtilService;

    this.mySchoolCommonRoom = {};
    this.schoolYear = 0;
    this.schoolNextYear = 0;
    this.schoolYearText = '';
    this.months = [];
    this.columnKeys = ['month', 'topic'];
  }

  $onInit() {
    this.mySchoolCommonRoom = this.SchoolCommonRoomService.getMySchoolCommonRoom();
    this.schoolYear = parseInt(this.mySchoolCommonRoom.schoolYear, 10);
    this.schoolNextYear = this.schoolYear + 1;
    this.schoolYearText = this.schoolYear + '/' + this.schoolNextYear;

    this.months = this.UtilService.getAllMonths();

    if (this.me.roleName === 'MANAGER') {
      this.columnKeys.push('id');
    }
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.activities) {
      this.activities = Object.assign([], this.activities);
    }
  }

  loadActivities(monthId = 0) {
    if (monthId > 0) {
      this.selectedMonth = monthId;
    }

    this.ActivityService.get(this.selectedMonth, true).then(activities => {
      this.activities = Object.assign([], activities);
      let toastText = 'Pomyślnie pobrano zajęcia';
      if (activities.length === 0) {
        toastText = 'Nie masz zajęć na ten miesiąc';
      }

      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent(toastText)
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(({MessagePL}) => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(MessagePL)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  add(form, ev) {
    if (form.$invalid) {
      return false;
    }

    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddActivityController',
      template: addActivityTemplate,
      locals: {months: this.months, selectedMonth: this.selectedMonth},
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(monthToDisplay => {
      // If you add activity to different month, load activities from this month
        if (monthToDisplay !== this.selectedMonth) {
          this.selectedMonth = null;
          this.ActivityService.get(null, true).then(activities => {
            this.activities = Object.assign([], activities);
          });
        } else if (this.selectedMonth) {
          this.ActivityService.get(this.selectedMonth, true).then(activities => {
            this.activities = Object.assign([], activities);
          });
        }
      }, () => {});
  }

  edit(activityId, ev) {
    const activityToEdit = {...this.activities.filter(item => item.id === activityId)[0]};
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditActivityController',
      template: editActivityTemplate,
      locals: {months: this.months, activity: activityToEdit},
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(() => {
        let monthId = this.selectedMonth;
        if (angular.isUndefined(this.selectedMonth)) {
          monthId = null;
        }

        this.ActivityService.get(monthId, true).then(activities => {
          this.activities = Object.assign([], activities);
        });
      }, () => {});
  }

  remove(activityId) {
    this.ActivityService.delete(activityId).then(() => {
      _remove(this.activities, activity => activity.id === activityId);
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto zajęcie')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  getMonthName(monthNumber) {
    return this.UtilService.getMonthName(monthNumber);
  }
}

export const Activities = {
  bindings: {
    me: '<',
    activities: '<'
  },
  template,
  controller: ActivitiesComponent
};
